import React from 'react';
import { Icon } from 'semantic-ui-react';
import TextField from 'components/ui/TextField';
import TextArea from 'components/forms/ui/TextArea';
import { useNJTaxSearch } from '../NJTaxSearchContext';
import { XIcon } from 'components/ui/icons';
import YearOrDate from './YearOrDate';

export const BaseLotTaxes = () => {
  const {
    createBaseLotTax,
    changeBaseLotTax,
    deleteBaseLotTax,
    baseLotTaxes,
    getYearOptions,
  } = useNJTaxSearch();
  return (
    <div style={{ paddingBottom: 32, marginTop: 32, borderBottom: '1px solid rgb(229, 229, 234)' }}>
      <div style={{ fontSize: 18, fontWeight: 900 }}>Base Lot Taxes</div>
      {baseLotTaxes.map((pc, index) => {
        return (
          <div style={{ backgroundColor: '#f5f5f5', padding: 16, marginTop: 16, borderRadius: 4 }}>
            <div
              style={{
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 8,
              }}
              onClick={() => deleteBaseLotTax(index)}
            >
              <XIcon />
            </div>
            <div style={{ display: 'flex', marginBottom: 24 }}>
              <YearOrDate
                options={getYearOptions()}
                customDate={pc.customDate}
                onChange={e => changeBaseLotTax('year', e, index)}
                yearValue={pc.year}
                onChangeCustomDate={e => {
                  changeBaseLotTax('customDate', e.target.value, index);
                }}
              />
              <TextField
                label="Quarter:"
                width="296px"
                value={pc.quarter || ''}
                onChange={e => changeBaseLotTax('quarter', e.target.value, index)}
                styles={{ marginLeft: 16 }}
              />
            </div>
            <TextArea
              value={pc.additionalInfo || ''}
              onChange={(e: any) => changeBaseLotTax('additionalInfo', e.target.value, index)}
              styles={{
                marginTop: 8,
                width: 296,
                height: 48,
                borderRadius: 5,
                resize: 'vertical',
                ':focus': {
                  outline: 'none',
                },
              }}
              label="Additional Information:"
              error={false}
              placeholder=""
              maxLength={52000}
            />
          </div>
        );
      })}
      <div style={{ cursor: 'pointer', display: 'flex', marginTop: 24 }} onClick={createBaseLotTax}>
        <Icon name="plus" />
        <span style={{ fontWeight: 'bold', marginLeft: 4, fontSize: 16 }}>Add Base Lot Tax</span>
      </div>
    </div>
  );
};
